import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import copy from 'copy-to-clipboard';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import { getClient, getQuery } from '@src/utils/index';
import { Grounds } from '@ifeng/client_grounds';
import { add } from '@src/services/api';
import useLogin from '@src/hook/useLogin';
import useSina from '@src/hook/useSina';
import { QQShare } from '@ifeng/three_terminal/es/mobile/qqShare/dynamic';

const Layout = ({ content, setToastShow, setToastContent, sharecb }) => {
    const { pageData } = content;
    const [show, setShow] = useState(false);
    const { canClick, isLogin, gotoLogin } = useLogin();
    const { openMenu } = useSina();
    const { openShare } = getQuery();
    const clientType = getClient();

    const afterShare = async () => {
        const resAdd = await add();

        if (resAdd && resAdd.code === 200) {
            if (sharecb) {
                sharecb();
            }
        }
    };

    const shareSina = () => {
        if (clientType === 'weibo') {
            openMenu({ pageData, successFn: afterShare });
        }
    };

    useEffect(() => {
        if (openShare) {
            shareSina();
        }
    }, []);

    const showMask = async () => {
        // 判断是什么端决定用什么分享

        if (canClick()) {
            // if (!isLogin()) {
            //     await gotoLogin({ openShare: true });
            // }
            if (clientType === 'weibo') {
                shareSina();
            } else if (clientType === 'weixin') {
                setShow(true);
                // 分享后投票数增加
                // add();
            } else if (clientType === 'native') {
                Grounds.newShare({
                    shareurl: pageData.shareUrl,
                    title: pageData.shareTitle,
                    desc: pageData.shareDesc,
                    thumb: pageData.shareImgUrl,
                });
                // 分享后投票数增加
                afterShare();
            }
        } else {
            copy(window.location.href);
            setToastContent('活动地址已复制进剪切板');
            setToastShow(true);
            if (isLogin()) {
                afterShare();
            }
        }
    };
    const hideMask = () => {
        setShow(false);
    };

    return (
        <div className={styles.layout}>
            <div className={styles.shareBtn} onClick={showMask} />
            {show ? (
                <div className={styles.mask}>
                    <div className={styles.tips} />
                    <div className={styles.close} onClick={hideMask} />
                </div>
            ) : (
                ''
            )}
            {pageData ? (
                <QQShare
                    content={{
                        title: pageData.shareTitle,
                        img: pageData.shareImgUrl,
                        desc: pageData.shareDesc,
                        url: pageData.shareUrl,
                        cb: () => {
                            console.log('分享成功');
                            afterShare();
                        },
                    }}
                />
            ) : null}
        </div>
    );
};

Layout.propTypes = {
    content: PropTypes.object,
    setToastShow: PropTypes.func,
    setToastContent: PropTypes.func,
    sharecb: PropTypes.func,
};

export default errorBoundary(Layout);
